module.exports = __webpack_public_path__ + "img/succ-bg.7276431c.png";